module.exports = __webpack_public_path__ + "img/invite_teammates.76180f26.svg";